import { Text, Title } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { useHistory } from "react-router-dom";

import { ListLoadingState } from "../../components/ListLoadingState";
import { TextButton } from "../../components/TextButton";
import { IN_HOME_BOOKED_VISIT_HISTORY_FULL_PATH } from "../paths";
import { useWorkerBookedVisitsData } from "../useWorkerBookedVisitsData";
import { InHomeBookedVisitCard } from "./Card";

export function InHomeBookedVisitsList() {
  const {
    regularVisits,
    caseIdToPatientMap,
    caseIdToWorkplaceNameMap,
    caseIdToSpecialtiesMap,
    isVisitsLoading,
  } = useWorkerBookedVisitsData();
  const history = useHistory();

  if (isVisitsLoading) {
    return <ListLoadingState texts={["Loading your booked visits"]} />;
  }

  return (
    <Stack spacing={5} sx={{ py: 5 }}>
      {regularVisits.length > 0 && (
        <Stack
          direction="row"
          alignItems="baseline"
          justifyContent="space-between"
          sx={{ paddingX: 2 }}
        >
          <Stack direction="row" alignItems="baseline" spacing={4}>
            <Title component="h2" variant="h5" paddingY={3}>
              In-home visits{" "}
            </Title>
            <Text semibold variant="body2" color={(theme) => theme.palette.text.tertiary}>
              {regularVisits.length}
            </Text>
          </Stack>
          <TextButton
            onClick={() => {
              history.push(IN_HOME_BOOKED_VISIT_HISTORY_FULL_PATH);
            }}
          >
            Case History
          </TextButton>
        </Stack>
      )}
      {regularVisits.map((visit) => {
        const patient = caseIdToPatientMap.get(visit.attributes.caseId);
        const specialties = caseIdToSpecialtiesMap.get(visit.attributes.caseId);
        const workplaceName = caseIdToWorkplaceNameMap.get(visit.attributes.caseId);

        return (
          <InHomeBookedVisitCard
            key={visit.id}
            visit={visit}
            patient={patient}
            specialties={specialties ?? []}
            workplaceName={workplaceName ?? ""}
          />
        );
      })}
    </Stack>
  );
}
